import React from 'react';
import {Form, Input, Button} from 'antd';
import './style.scss'
import {Link} from "react-router-dom";

const ProForgotPassword = () => {
    const onFinish = (values) => {
        console.log('Received values of form: ', values);
    };

    return (
        <div style={{marginTop: '5vw'}}>
            <div className="Title">
                 Forgot password?
            </div>
            <p className="ProPassword-text">We'll email you instructions on how to reset your password</p>
            <Form
                initialValues={{remember: true}}
                onFinish={onFinish}
                colon={false}
                layout="horizontal"
            >
                <Form.Item
                    label={<span className="email-label">Email</span>}
                    name="email"
                    rules={[{message: 'Please input your email!'}]}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 5}}
                >
                    <Input className={'input-Email-form'}/>
                </Form.Item>
            </Form>

            <div className="center-button">
                <Button type="primary" htmlType="submit" className="custom-Reset-button">
                    Reset password
                </Button>
            </div>
        </div>
    );
};

export default ProForgotPassword;
